const Icon = ({
  iconName,
  isAmenity = false,
  tooltip,
  black = false,
  ...rest
}) => {
  return (
    <span
      className={isAmenity ? "amenity__icon" : "room__icon"}
      data-tooltip={tooltip}
      style={{ color: "#000" }}
      {...rest}
    >
      {iconName}
    </span>
  );
};

export default Icon;
